// import React from 'react';
// import DataTable, { createTheme } from 'react-data-table-component';
// import Checkbox from '@material-ui/core/Checkbox';
// import ArrowDownward from '@material-ui/icons/ArrowDownward';

//   const handleChange = (state) => {
//     // You can use setState or dispatch with something like Redux so we can use the retrieved data
//     console.log('Selected Rows: ', state.selectedRows);
//   };

//   const sortIcon = <ArrowDownward />;
//   const selectProps = { indeterminate: isIndeterminate => isIndeterminate };
// export default function Datatable(props){
//     return (
//         <DataTable
//       title="Arnold Movies"
//       columns={props.columns}
//     //   theme="solarized"
//       data={props.data}
//       selectableRows // add for checkbox selection
//       selectableRowsComponent={Checkbox}
//     //   selectableRowsComponentProps={{ inkDisabled: true }} 
//     Clicked
//     onSelectedRowsChange={handleChange}
//     sortIcon={sortIcon} 
//     selectableRowsComponentProps={selectProps}
//     pagination={true}
    
//     paginationPerPage="5"
//     paginationRowsPerPageOptions={[5,10,15]}
//     />
//     )
// }



import React from "react";
// import MUIDataTable from "mui-datatables";
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import MUIDataTable, { TableFilterList } from "mui-datatables";
import Chip from '@material-ui/core/Chip';
import MaterialIcons from '../component/MaterialIcons';

const CustomChip = ({ label, onDelete }) => {
    return (
        <Chip
            variant="outlined"
            color="secondary"
            label={label}
            onDelete={onDelete}
        />
    );
};

const CustomFilterList = (props) => {
    return <TableFilterList {...props} ItemComponent={CustomChip} />;
};

// class BodyCellExample extends React.Component {

  

//   render() {

    

//   }
// }

export default function Datatable(props){

    const getMuiTheme = () => createMuiTheme({
        overrides: {
          MUIDataTableBodyCell: {
            root: {
             // backgroundColor: "#FF0000"
            }
          }
        }
      })
    return (
        <div>
          <MuiThemeProvider theme={getMuiTheme()}>
            <MUIDataTable 
              title={props.title} 
              data={props.data} 
              columns={props.columns} options={props.options}
              components={{
              TableFilterList: CustomFilterList,
          }}
          />
        </MuiThemeProvider>
        </div>
        
      );
}


// WEBPACK FOOTER //
// ./src/component/Datatable.js